import BaseModelAPI from '../BaseModelAPI';

export default class ShiftList extends BaseModelAPI {

	static entity = 'shiftlist'
	static entityName = 'shift';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
